module.exports = __webpack_public_path__ + "img/arrow-left.e1ce6c18.svg";